import i18n from '@/i18n';

export function compactUZS(value: number) {
  const v = Number(value ?? 0);
  if (Math.abs(v) >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1)} ${i18n.t('tick_reports.unitBillion')}`;
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1)} ${i18n.t('tick_reports.unitMillion')}`;
  if (Math.abs(v) >= 1_000) return `${Math.round(v / 1_000)} ${i18n.t('tick_reports.unitThousand')}`;
  return String(v);
}

export function ChartTooltipBox({
  title,
  rows,
}: {
  title: string;
  rows: { label: string; value: string }[];
}) {
  return (
    <div className="rounded-lg border border-border bg-popover px-3 py-2 shadow-md">
      <p className="text-xs font-medium text-foreground mb-1">{title}</p>
      {rows.map((r) => (
        <div key={r.label} className="flex items-center justify-between gap-4 text-xs">
          <span className="text-muted-foreground">{r.label}</span>
          <span className="text-foreground font-medium">{r.value}</span>
        </div>
      ))}
    </div>
  );
}

export const CHART_COLORS = [
  'hsl(var(--primary))',
  'hsl(var(--success))',
  'hsl(var(--warning))',
  'hsl(var(--info))',
  'hsl(var(--destructive))',
  'hsl(var(--accent-foreground))',
  'hsl(var(--muted-foreground))',
  'hsl(var(--secondary-foreground))',
];
